import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,

  state() {
    return {
      notifications: [],
      unreadCount: 0,
      unreadMes: 0,
      orderRefreshTrigger: 0,
      lastNewOrderId: null,
    };
  },
  mutations,
  actions,
  getters,
};
